import { createReducer, on } from '@ngrx/store';
import { IDataGetmTienda } from '../../private/shared/models/productos';
import { errorGetmTienda, getGetmTienda, resetGetmTienda, successGetmTienda } from '../actions';

export interface GetmTiendaState {
    error: any | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    data: IDataGetmTienda;
}

export const GetmTiendaInitState: GetmTiendaState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: {
        fulldata: true,
        favoritos: [],
        tendencias: [],
        promos: [],
        categorias: {
            products: [],
            categories: [],
            groupers: []
        },
        ttl_segundos: 0,
        _errors: {}
    },
};

export const getmTiendaReducer = createReducer(
    GetmTiendaInitState,
    on(getGetmTienda, state => ({
        ...state,
        loading: true,
        failed: false,
        success: false,
    })),
    on(successGetmTienda, (state, { data }) => ({
        ...state,
        loading: false,
        success: true,
        data: data ? {
            ...data,
            promos: data.promos.map(p => ({ ...p, MaximoPaquetes: p.MaximoPaquetes - p.PaquetesCanjeados, PaquetesCanjeados: 0 })),
            favoritos: data.favoritos.map(fav => {
                const isPromo = fav.principal && 'ClavePromo' in fav.principal;
                const adjustedPrincipal = isPromo ? { ...fav.principal, MaximoPaquetes: fav.principal.MaximoPaquetes - fav.principal.PaquetesCanjeados, PaquetesCanjeados: 0 } : fav.principal;
                const adjustedAdicionales = fav.adicionales && fav.adicionales.length > 0 ?
                    fav.adicionales.map(a => {
                        const isAdicionalPromo = 'ClavePromo' in a;
                        return isAdicionalPromo ? { ...a, MaximoPaquetes: a.MaximoPaquetes - a.PaquetesCanjeados, PaquetesCanjeados: 0 } : a;
                    })
                    : [];
                return { ...fav, principal: adjustedPrincipal, adicionales: adjustedAdicionales };
            }),
            fulldata: true
        } : { ...GetmTiendaInitState.data, fulldata: false },
    })),
    on(errorGetmTienda, (state, { payload }) => ({
        ...state,
        loading: false,
        failed: true,
        error: payload,
    })),
    on(resetGetmTienda, state => ({ ...state, ...GetmTiendaInitState, }))
);
